import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { getToken } from '@/libs/session'
import store from '@/store'

Vue.use(VueRouter)

/**
 * 这里用于防止路由到相同地址导致的console报错
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'hash',
  routes
})
let LoginName;
// 登录界面路由名
if (window.location.host.indexOf('localhost') == -1 && window.location.host.indexOf('127.0.0.1') == -1) {
  LoginName = 'login'
} else {
  // test token
  LoginName = 'testView'
}
// LoginName = 'login'
/**
 * 路由进入前检查
 */
router.beforeEach((to, from, next) => {
  this.a.app.$loading.hide();
  if (to.name === LoginName) {
    next()
  } else if (!getToken() && to.name !== LoginName) {
    next({ name: LoginName })
  } else if (to.matched.length === 0) {
    next({ name: LoginName })
  } else {
    // 检查用户信息是否存在
    if (store.state.user.hasUserInfo) {
      next()
    } else {
      store.dispatch('getUserInfo').then(info => {
        !info.error ? next() : next({ name: LoginName })
      })
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js